import { render, staticRenderFns } from "./AppHeaderLogo.vue?vue&type=template&id=5530428b&scoped=true&"
import script from "./AppHeaderLogo.vue?vue&type=script&lang=js&"
export * from "./AppHeaderLogo.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderLogo.vue?vue&type=style&index=0&id=5530428b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5530428b",
  null
  
)

export default component.exports